<template>
  <div class="creation-date-cell">
    <div class="creation-date-cell__date" :class="{invalid: !isValidDate}">
      <div class="creation-date-cell__date__container">
        {{ formattedDate }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CreationDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return moment(this.item.date).format('DD/MM/YYYY HH:mm');
    },
    isValidDate() {
      return this.item.valid;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.creation-date-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: $font-family-regular;
  &__date {
    justify-content: center;
    height: rem(30);
    border-radius: $radius-md;
    width: fit-content;
    text-align: left;
    padding: 0 $space-2;
    display: flex;
    color: var(--severity-low);
    background-color: var(--severity-low-bg);
    &.invalid {
      color: var(--severity-critical);
      background-color: var(--severity-critical-bg);
    }
    &__container{
      margin-top: rem(-13);
    }
  }
}
</style>
